export const webAPIConstants = {
	GetPaged: {
		FAILURE : 'GET_PAGED_WEB_API_FAILURE',
		REQUEST : 'GET_PAGED_WEB_API_REQUEST',
		SUCCESS : 'GET_PAGED_WEB_API_SUCCESS'
	},
	Register: {
		FAILURE : 'REGISTER_WEB_API_FAILURE',
		REQUEST : 'REGISTER_WEB_API_REQUEST',
		SUCCESS : 'REGISTER_WEB_API_SUCCESS'
	},
	Reset: {
		FAILURE : 'RESET_WEB_API_FAILURE',
		REQUEST : 'RESET_WEB_API_REQUEST',
		SUCCESS : 'RESET_WEB_API_SUCCESS'
	},
	CLEAR      : 'CLEAR_WEB_API',
	CLEAR_INFO : 'CLEAR_WEB_API_INFO'
}